import {
  SAVE_PAST_ORDER,
  SAVE_LAST_ORDER,
  CLEAR_LAST_ORDER
} from "./actionTypes";

export const savePastOrder = promiseID => {
  return {
    type: SAVE_PAST_ORDER,
    payload: promiseID
  };
};

export const saveLastOrder = response => {
  return {
    type: SAVE_LAST_ORDER,
    payload: response
  };
};

export const clearLastOrder = response => {
  return {
    type: CLEAR_LAST_ORDER,
    payload: response
  };
};
